<template>
    <div class="mobile-menu mobile-menu--lang-switcher" :class="{'mobile-menu--fullsize': mobileLangSwitcher}">
        <template v-if="mobileLangSwitcher">
            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_LANG_SWITCHER', false)"
               class="mobile-menu__btn -red">
                <span class="material-icon icon-clear"/>
            </a>
            <div class="mobile-menu__container js-mobile-menu-container">
                <div class="mobile-menu__container-inner">
                    <div class="mobile-menu__content">
                        <ul class="mobile-menu__links">
                            <li v-for="(lang, i) in availableLocales" :key="i" class="mobile-menu__link">
                                <a href="#" @click.prevent="setLocale(lang.iso)" :class="{active: lang.iso === $i18n.locale}">
                                    {{ lang.name || lang.iso }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
        <a href="#" v-else @click.prevent="$store.dispatch('SET_MOBILE_LANG_SWITCHER', true)"
           class="mobile-menu__lang-switcher">
            <span class="material-icon icon-keyboard_arrow_down"/>
            {{ $i18n.locale }}
        </a>
    </div>
</template>

<script>
  import MobileLangSwitcher from 'src/mixins/mobileLangSwitcherComponent';

  export default {
    mixins: [MobileLangSwitcher],
  };
</script>
